import LeadDocumentUpload from "../layout/driverLeadCreationV2/LeadDocumentUpload";
import PageLayout from "./PageLayout";

const LeadDocumentUploadPage = () => {
  return (
    <PageLayout sx={{ px: 0, py: 0 }}>
      <LeadDocumentUpload />
    </PageLayout>
  );
};

export default LeadDocumentUploadPage;
